var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M18.897604,55 L8.60792956,55 L8.60792956,23.9625393 L18.897604,23.9625393 L18.897604,55 Z M13.7530891,19.7243705 L13.6860428,19.7243705 C10.2331578,19.7243705 8,17.3412488 8,14.3628316 C8,11.3171931 10.3014936,9 13.8214247,9 C17.3413561,9 19.5074676,11.3171931 19.5745139,14.3628316 C19.5745139,17.3412488 17.3413561,19.7243705 13.7530891,19.7243705 Z M56,55 L45.7116149,55 L45.7116149,38.3957116 C45.7116149,34.2228249 44.2217686,31.376911 40.4987644,31.376911 C37.6563877,31.376911 35.9634684,33.2965941 35.2195121,35.1497021 C34.9474589,35.8128654 34.8810572,36.7397425 34.8810572,37.6672662 L34.8810572,55 L24.5920275,55 C24.5920275,55 24.7267649,26.8743818 24.5920275,23.9625393 L34.8810572,23.9625393 L34.8810572,28.3571268 C36.2484153,26.2422437 38.6949607,23.2340941 44.1540775,23.2340941 C50.9238207,23.2340941 56,27.6700483 56,37.2031811 L56,55 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linked-in-icon.08a22f167e95cb11425282f32e5b57d5.svg";
export { ForwardRef as ReactComponent };